import axios from "axios";

export const RSE_PROJECTS_ENDPOINT = "/reportes-salud-emergencia/proyectos";
export const RSE_SUMMARY_ENDPOINT = "/reportes-salud-emergencia/resumen";
export const RSE_EXPORT_ENDPOINT = "/reportes-salud-emergencia/export";
export const RSE_EDAD_SEXO_ENDPOINT = "/reportes-salud-emergencia/edad-sexo";
export const RSE_COMUNIDADES_ENDPOINT = "/reportes-salud-emergencia/comunidades";
export const RSE_CALIDAD_ENDPOINT = "/reportes-salud-emergencia/calidad";
export const RSE_PATOLOGIAS_ENDPOINT = "/reportes-salud-emergencia/patologias";
export const RSE_PATOLOGIAS_COMUNIDAD_ENDPOINT =
  "/reportes-salud-emergencia/patologias-comunidad";

export const getRseProjects = async () => {
  const response = await axios.get(RSE_PROJECTS_ENDPOINT);
  const payload = response?.data || {};

  return {
    projects: Array.isArray(payload.data) ? payload.data : [],
    projectScope: payload.meta?.projectScope || "",
    meta: payload.meta || {},
  };
};

export const getRseSummary = async (params) => {
  const response = await axios.get(RSE_SUMMARY_ENDPOINT, { params });
  return response?.data?.data || {};
};

const getAnalyticsDataset = async (endpoint, params) => {
  const response = await axios.get(endpoint, { params });
  return response?.data?.data || {};
};

export const getRseEdadSexo = (params) =>
  getAnalyticsDataset(RSE_EDAD_SEXO_ENDPOINT, { ...params, tipo: "atenciones" });

export const getRseComunidades = (params) =>
  getAnalyticsDataset(RSE_COMUNIDADES_ENDPOINT, params);

export const getRsePatologias = (params) =>
  getAnalyticsDataset(RSE_PATOLOGIAS_ENDPOINT, params);

export const getRsePatologiasComunidad = (params) =>
  getAnalyticsDataset(RSE_PATOLOGIAS_COMUNIDAD_ENDPOINT, params);

export const getRseCalidad = (params) =>
  getAnalyticsDataset(RSE_CALIDAD_ENDPOINT, params);

export const downloadRseExcel = (params) =>
  axios.get(RSE_EXPORT_ENDPOINT, {
    params,
    responseType: "blob",
  });
